export default function buildPostFilterParam({
    apiEndpoint,
    apiTools
}) {
    return async function postFilterParam(args) {
        const url = apiTools.resolveUrl({
            ...args,
            apiEndpoint: `${ apiEndpoint }/param` 
        })
       
        const res = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
            'Authorization': 'salaTokken'
            },
            credentials: 'include',
            body: JSON.stringify(args.body)
        });
        return await res.json();
    }
}